import { APIClient } from 'infra/APIClient'
import { APIConfig } from 'types/definitions'
import { JobRelationshipManagerResource } from './dtos/relationship-manager'

/**
 * Client for flock api.
 */
export interface FlockAPI {
  relationshipManager: RelationshipManagerAPI
}

export function createFlockAPI(opts: APIConfig): FlockAPI {
  return {
    relationshipManager: new RelationshipManagerAPI(opts),
  }
}

export class RelationshipManagerAPI extends APIClient {
  getForJob(jobId: string): Promise<JobRelationshipManagerResource> {
    return this.client
      .get<JobRelationshipManagerResource>(
        `/v1/relationship-managers/jobs/${encodeURIComponent(jobId)}`,
      )
      .then(this._data)
  }
}
